export const homeRoutes = {
  home: "",
} as const;
